import { cloneDeep } from 'lodash-es';

export class GeoJsonLineString implements GeoJSON.Feature<GeoJSON.LineString> {
    type = 'Feature' as const;
    geometry: GeoJSON.LineString;
    properties: GeoJSON.GeoJsonProperties;

    constructor(
        coordinates: number[][] = [],
        properties: GeoJSON.GeoJsonProperties = {},
        id?: string
    ) {
        this.geometry = {
            coordinates: [...coordinates] as GeoJSON.Position[],
            type: 'LineString',
        };
        this.properties = cloneDeep(properties);
        this.properties ??= {};

        if (id) {
            this.properties.id = id;
        }
    }
}
